import {
  Component,
  ChangeDetectionStrategy
} from '@angular/core';

@Component({
  selector: 'cs-loader',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `    
    <div class="cs-loader-overlay">
        <div class="cs-loader">
            <div class="bounce1"></div>
            <div class="bounce2"></div>
            <div class="bounce3"></div>
        </div>
    </div>
  `
})

export class CsLoaderComponent { }



// WEBPACK FOOTER //
// ./src/app/components/cs-loader/cs-loader.component.ts